export default class ApiResponseError extends Error {
  constructor(response, data) {
    super();
    this.response = response;
    this.data = data;
    this.message = this.getMessage(response, data);
    this.stack = (new Error(this.message)).stack;
    this.name = this.constructor.name;
  }

  errorFields = () => {
    return this.data.body.errors
  }

  getMessage = (response, data) => {
    let message = 'Error desconocido';
    switch (response.status) {
      case 400:
        switch(data.code) {
          case 1: message = 'Error, las contraseñas no coinciden.'; break;
          case 4: message = 'Error, token inválido.'; break;
          case 18: message = 'Error, parámetros inválidos.'; break;
          case 20: message = 'Advertencia, versión base no existe.'; break;
          case 21: message = 'Error, estilos no configurados.'; break;
          case 22: message = 'Error, el tipo de vista ya está asignado.'; break;
          default: message = data.error; break;
        }
        break;
      case 401:
        switch(data.code) {
          case 23: message = 'Ha ocurrido un error inesperado, por favor contactar a'; break;
          default: message = 'Error de Autenticación'; break;
        }
        break;
      case 402: message = 'Error, pago requerido'; break;
      case 403: message = 'Error, no tiene autorización.'; break;
      case 404:
        switch(data.code) {
          case 16: message = 'Error, noticias no encontradas'; break;
          default: message = data.error; break;
        }
        break;
      case 405: message = 'Error, método no permitido'; break;
      case 406: message = 'Error, no aceptado'; break;
      case 407: message = 'Error, se requiere autenticación proxy'; break;
      case 408: message = 'Error, solicitud fuera de tiempo'; break;
      case 409:
        switch(data.code) {
          case 8: message = 'Error, parámetros inválidos'; break;
          case 9: message = 'Error, parámetros inválidos'; break;
          case 14: message = 'Error, grupo inválido'; break;
          default: message = data.error; break;
        }
        break;
      case 410: message = 'Error, el recurso ya no existe'; break;
      case 411: message = 'Error, longitud requerida'; break;
      case 412: message = 'Error, precondición fallida'; break;
      case 413: message = 'Error, entidad demasiado grande'; break;
      case 414: message = 'Error, uri demasiado grande'; break;
      case 415: message = 'Error, tipo de entrada no soportada'; break;
      case 416: message = 'Error, rango solicitado no satisfactorio'; break;
      case 417: message = 'Error, expectativa fallida'; break;
      case 422: message = 'Error, entidad no procesada'; break;
      case 423: message = 'Error, bloqueado'; break;
      case 424: message = 'Error, dependecia fallida'; break;
      case 426: message = 'Error, actualización requerida'; break;
      case 430: message = 'Error, solicitud fuera de tiempo'; break;
      case 500:
        switch(data.code) {
          case 15: message = 'Error, no se pudo conectar con refinitiv'; break;
          default: message = data.error; break;
        }
        break;
    }
    return message;
  }
}
